export default __webpack_public_path__ + "64a9f46fe3b5c012fbf039cffdd8732a.jpg";